import { FC } from 'react';

interface PROPS {
  loading?: boolean;
  progressCount: number;
}

const Progress: FC<PROPS> = ({ loading, progressCount }) => {
  if (loading) {
    return (
      <span className="mr-1">
        ({progressCount}
        %)
      </span>
    );
  }
  return <span />;
};

export default Progress;
